<template>
  <!-- 字幕和气泡模块 -->
  <div class="text" id="TEXT-SWF">
    <div class="mask_" v-show="mask_visible_"></div>
    <div class="tabs">
      <div v-for="item, index in tabs_data"
           :class="{'active':item.active}"
           @click="handleTabsChange(index, tabs_data)">{{item.name}}</div>
    </div>
    <div class="con">
      <div v-show="type == 0">
        <div class="toolbar" style="height:50px">
          <div class="font-family">
            <div class="inner">
              <el-select v-model="form_subtitles.font_family" style="font-size:12px;" placeholder="字体" @change="handleSubtitlesFontFamilyChange">
                <el-option
                  v-for="item in form_subtitles.font_family_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :style="'font-size: 12px; font-family:' + item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="font-size" style="width:62px;position:relative;left:90px;top:-26px;padding-right:0px;">
            <el-select v-model="form_subtitles.font_size" placeholder="字号" @change="handleSubtitlesFontFizeChange">
              <el-option
                v-for="item in form_subtitles.font_size_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                style="font-size: 12px;">
              </el-option>
            </el-select>
          </div>
          <el-color-picker v-model="form_subtitles.color" size="medium" style="margin-left:150px;width:20px;height:20px;top:-57px" @change="handleSubtitlesColorChange"></el-color-picker>
          <div class="align">
            <div
              :class="{'active':item.active}"
              v-for="item,index in halign_data"
              @click="handleSubtitlesHalignChange(index, halign_data)">
                <i :class="item.class"></i>
            </div>
          </div>
        </div>
        <div class="subtitles">
          <div class="title">字幕文字输入框<span v-show="tip_visible">最多输入 <strong>512</strong> 个字符</span></div>
          <div class="content"><el-input class="subtitles_con" type="textarea" resize="none" v-model="form_subtitles.content" v-on:input="handleSubtitlesChange"></el-input></div>
        </div>
        <!-- 字幕列表区域 -->
        <div v-show="false" class="subtitles-list-wrapper">
          <div class="subtitles-list-header">
            <span>当前页字幕列表</span>
            <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
          </div>
          <div class="subtitles-list-content">
            <div class="subtitle-item" 
                 v-for="(item, index) in currentPageSubtitles" 
                 :key="index"
                 :class="{'active': currentStepIndex === index}"
                 @click="handleStepClick(index)">
              <!-- 左侧选择框 -->
              <div class="subtitle-checkbox">
                <el-checkbox v-model="item.selected" @change="handleItemSelect(index)"></el-checkbox>
              </div>
              
              <!-- 中间文本输入区域 -->
              <div class="subtitle-input">
                <el-input 
                  type="textarea" 
                  v-model="item.text" 
                  :rows="2"
                  resize="none"
                  placeholder="请输入字幕文字..."
                  @input="handleSubtitleTextChange(index)"
                  @focus="handleStepClick(index)">
                </el-input>
              </div>
            </div>
            
            <!-- 空状态提示 -->
            <div class="empty-state" v-if="currentPageSubtitles.length === 0">
              <i class="el-icon-document"></i>
              <p>当前页暂无字幕</p>
            </div>
          </div>
        </div>
        
        <!-- TTS 参数设置区域 -->
        <div class="tts-params-wrapper">
          <div class="tts-params-header">
            <i class="el-icon-setting"></i>
            <span>语音参数设置</span>
          </div>
          <div class="tts-params-content">
            <div class="param-row">
                <!-- 右侧音色和情感 -->
                <div class="subtitle-voice">
                    <el-popover
                      placement="bottom"
                      width="320"
                      trigger="click"
                      v-model="voicePopoverVisible">
                      <div class="voice-selector-panel">
                        <!-- Tab切换 -->
                        <div class="voice-tabs">
                          <div 
                            v-if="team_id"
                            :class="['voice-tab', { active: voiceTabActive === 'team' }]"
                            @click="voiceTabActive = 'team'">
                            {{ team_name || '团队音色' }}
                          </div>
                          <div 
                            :class="['voice-tab', { active: voiceTabActive === 'public' }]"
                            @click="voiceTabActive = 'public'">
                            公共音色
                          </div>
                          <div 
                            :class="['voice-tab', { active: voiceTabActive === 'my' }]"
                            @click="voiceTabActive = 'my'">
                            我的音色
                          </div>
                        </div>
                        
                        <!-- 团队音色列表 -->
                        <div v-show="voiceTabActive === 'team'" class="voice-list">
                          <div class="voice-list-header">
                            <i class="el-icon-refresh" @click="loadTeamVoiceList" :class="{rotating: team_voice_loading}" title="刷新"></i>
                          </div>
                          <div 
                            v-for="voice in team_voice_list" 
                            :key="voice.voiceId"
                            :class="['voice-item', { selected: tts_global_config.voice === voice.voiceId }]"
                            @click="selectVoice(voice.voiceId)">
                            <div class="voice-info">
                              <span class="voice-name">{{ voice.voiceName }}</span>
                            </div>
                            <div class="voice-actions">
                              <span v-if="voice.expirationTime" class="voice-expiration">
                                过期日期: {{ formatExpirationTime(voice.expirationTime) }}
                              </span>
                              <i v-if="tts_global_config.voice === voice.voiceId" class="el-icon-check"></i>
                              <i v-if="voice.canDeleted" class="el-icon-delete" @click.stop="deleteTeamVoice(voice.voiceId)"></i>
                            </div>
                          </div>
                          <div v-if="team_voice_list.length === 0 && !team_voice_loading" class="voice-empty">
                            <i class="el-icon-microphone"></i>
                            <p>暂无团队音色</p>
                          </div>
                          <div v-if="team_voice_loading" class="voice-loading">
                            <i class="el-icon-loading"></i> 加载中...
                          </div>
                          <!-- 添加音色按钮 -->
                          <div class="voice-add-btn" @click="openTeamVoiceManageDialog">
                            <i class="el-icon-plus"></i> 添加音色
                          </div>
                        </div>
                        
                        <!-- 公共音色列表 -->
                        <div v-show="voiceTabActive === 'public'" class="voice-list">
                          <div 
                            v-for="voice in voice_list" 
                            :key="voice.voiceId"
                            :class="['voice-item', { selected: tts_global_config.voice === voice.voiceId }]"
                            @click="handleVoiceClick(voice)">
                            <span class="voice-name">{{ voice.voiceName }}</span>
                            <i v-if="tts_global_config.voice === voice.voiceId" class="el-icon-check"></i>
                          </div>
                          <div v-if="voice_list_loading" class="voice-loading">
                            <i class="el-icon-loading"></i> 加载中...
                          </div>
                        </div>
                        
                        <!-- 我的音色列表 -->
                        <div v-show="voiceTabActive === 'my'" class="voice-list">
                          <div class="voice-list-header">
                            <i class="el-icon-refresh" @click="loadMyVoiceList" :class="{rotating: my_voice_loading}" title="刷新"></i>
                          </div>
                          <div 
                            v-for="voice in my_voice_list" 
                            :key="voice.voiceId"
                            :class="['voice-item', { selected: tts_global_config.voice === voice.voiceId }]"
                            @click="selectVoice(voice.voiceId)">
                            <div class="voice-info">
                              <span class="voice-name">{{ voice.voiceName }}</span>
                            </div>
                            <div class="voice-actions">
                              <span v-if="voice.expirationTime" class="voice-expiration">
                                过期日期: {{ formatExpirationTime(voice.expirationTime) }}
                              </span>
                              <i v-if="tts_global_config.voice === voice.voiceId" class="el-icon-check"></i>
                              <i v-if="voice.canDeleted" class="el-icon-delete" @click.stop="deleteMyVoice(voice.voiceId)"></i>
                            </div>
                          </div>
                          <div v-if="my_voice_list.length === 0 && !my_voice_loading" class="voice-empty">
                            <i class="el-icon-microphone"></i>
                            <p>暂无自定义音色</p>
                          </div>
                          <div v-if="my_voice_loading" class="voice-loading">
                            <i class="el-icon-loading"></i> 加载中...
                          </div>
                          <!-- 添加音色按钮 -->
                          <div class="voice-add-btn" @click="openMyVoiceManageDialog">
                            <i class="el-icon-plus"></i> 添加音色
                          </div>
                        </div>
                      </div>
                      <el-button slot="reference" size="small" style="width: 140px;">
                        <span style="float: left;">{{ getSelectedVoiceName() }}</span>
                        <i class="el-icon-arrow-down" style="float: right; margin-top: 4px;"></i>
                      </el-button>
                    </el-popover>
                    
                    <el-select v-model="tts_global_config.emotion" size="small" placeholder="情感" @change="handleEmotionChange" :disabled="!current_voice_emotions.length">
                        <el-option
                          v-for="emotion in current_voice_emotions"
                          :key="emotion.value"
                          :label="emotion.label"
                          :value="emotion.value">
                        </el-option>
                    </el-select>
                </div>
              <div class="param-item">
                <label>语速：</label>
                <el-slider 
                  v-model="tts_global_config.speed" 
                  :min="0.5" 
                  :max="2.0" 
                  :step="0.1"
                  :show-input-controls="false"
                  @change="handleTtsParamChange"
                  style="width: 180px;">
                </el-slider>
              </div>
              <div class="param-item">
                <label>音量：</label>
                <el-slider 
                  v-model="tts_global_config.volume" 
                  :min="0" 
                  :max="100" 
                  :step="1"
                  :show-input-controls="false"
                  @change="handleTtsParamChange"
                  style="width: 180px;">
                </el-slider>
              </div>
              <div class="param-item">
                <label>音调：</label>
                <el-slider 
                  v-model="tts_global_config.pitch" 
                  :min="0.5" 
                  :max="2.0" 
                  :step="0.1"
                  :show-input-controls="false"
                  @change="handleTtsParamChange"
                  style="width: 180px;">
                </el-slider>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 口型匹配区域 -->
        <div class="lip-sync-wrapper">
          <div class="lip-sync-header">
            <i class="el-icon-user"></i>
            <span>口型匹配</span>
          </div>
          <div class="lip-sync-content">
            <div class="param-row">
              <!-- 形象选择 -->
              <div class="lip-sync-character">
                <label>形象：</label>
                <el-select 
                  v-model="lip_sync_config.bundleAlias" 
                  size="small" 
                  placeholder="选择形象"
                  :loading="bundle_list_loading"
                  @change="handleCharacterChange">
                  <el-option
                    v-for="character in bundle_list"
                    :key="character.alias"
                    :label="getBundleName(character.id)"
                    :value="character.alias">
                    <div style="display: flex; align-items: center;">
                      <img 
                        v-if="getBundleThumb(character.id)" 
                        :src="getBundleThumb(character.id)" 
                        style="display: block; width: 26px; height: 26px; border: 1px solid #ccc; padding: 2px; margin-right: 8px; background: #fff; object-fit: cover; object-position: center top;" 
                      />
                      <span v-else style="width: 26px; height: 26px; margin-right: 8px; display: flex; align-items: center; justify-content: center; font-size: 16px;">🎭</span>
                      <span>{{ getBundleName(character.id) }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
              
              <!-- 情感选择 -->
              <div class="lip-sync-emotion">
                <label>表情：</label>
                <el-select 
                  v-model="lip_sync_config.emotion" 
                  size="small" 
                  placeholder="选择表情"
                  @change="handleLipSyncEmotionChange">
                  <el-option
                    v-for="emotion in lip_sync_emotions"
                    :key="emotion.value"
                    :label="emotion.label"
                    :value="emotion.value">
                    <div style="display: flex; align-items: center;">
                      <img :src="emotion.icon" style="width: 24px; height: 24px; margin-right: 8px;" />
                      <span>{{ emotion.label }}</span>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </div>
            
            <div class="param-row">
              <!-- 情感等级 -->
              <div class="param-item">
                <label>表情等级：</label>
                <el-slider 
                  v-model="lip_sync_config.emotionLevel" 
                  :min="0" 
                  :max="7" 
                  :step="1"
                  :show-input-controls="false"
                  show-stops
                  @change="handleEmotionLevelChange"
                  style="width: 180px;">
                </el-slider>
                <span class="param-value">{{ lip_sync_config.emotionLevel }}</span>
              </div>
            </div>
            
            <div class="lip-sync-actions">
              <el-checkbox v-model="lip_sync_config.autoGenerate" class="auto-generate-checkbox">
                自动生成
              </el-checkbox>
              <el-button 
                type="primary" 
                size="small"
                icon="el-icon-video-camera"
                @click="handleGenerateLipSync"
                :loading="lip_sync_generating"
                :disabled="generatedSentences.length==0">
                生成口型
              </el-button>
            </div>
          </div>
        </div>
        
        <!-- 生成按钮区域 -->
        <div class="tts-actions-wrapper">
          <div class="tts-status" v-if="tts_status_message">
            <i :class="tts_status_icon"></i>
            <span>{{ tts_status_message }}</span>
          </div>
          <div class="tts-buttons">
            <el-tooltip :content="tts_generating ? '生成中...' : '生成语音'" placement="top">
                <el-button 
                type="primary" 
                icon="el-icon-microphone" 
                @click="handleGenerateTTS"
                :loading="tts_generating"
                :disabled="!form_subtitles.content">
                </el-button>
            </el-tooltip>
            <el-tooltip content="试听" placement="top"> 
                <el-button 
                icon="el-icon-video-play" 
                @click="handlePreviewTTS"
                :disabled="!hasGeneratedAudio">
                </el-button>
            </el-tooltip>
            <el-dropdown @command="handleAddToTimeline" :disabled="!hasGeneratedAudio">
                <el-tooltip content="添加到时间轴" placement="top">
                    <el-button 
                    icon="el-icon-download" 
                    :disabled="!hasGeneratedAudio">
                    </el-button>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="voice">配音</el-dropdown-item>
                    <el-dropdown-item command="sound_effect">旁白</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            
          </div>
        </div>
      </div>
      <div v-show="type == 1">
        <div class="mask" v-show="mask_visible"></div>
        <div class="toolbar">
          <div class="font-family">
            <div class="inner" style="width:60px;height:25px;">
              <el-select v-model="form_bubble.font_family" size="mini" style="width:90px;" placeholder="字体"  @change="handleBubbleFontFamilyChange" :disabled="mask_visible">
                <el-option
                  v-for="item in form_bubble.font_family_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :style="'font-size: 12px; font-family:' + item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="color"> -->
            <el-color-picker v-model="form_bubble.color" size="medium" style="margin-left:110px;width:20px;height:20px;top:-30px" @change="handleBubbleColorChange" ></el-color-picker>
          <!-- </div> -->
        </div>
        <div class="subtitles" v-show="type == 1">
          <div class="title">气泡文字输入框</div>
          <div class="content"><el-input type="textarea" v-model="form_bubble.content" resize="none" v-on:input="handleBubbleChange" :disabled="mask_visible"></el-input></div>
        </div>
        <div class="bubble" v-show="type == 1">
          <div class="title">气泡样式</div>
          <div class="list">
              <div class="con">
                  <div class="item" v-for="item, index in bubble_data" @click="handleBubbleAdd(item.ori_data_id)"><img :src="item.thumb"></div>
              </div>
              <div class="more" @click="handleMore" v-show="more">
                  <div class="inner">加载更多</div>
              </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 音色管理对话框 -->
    <el-dialog
      title="音色管理"
      :visible.sync="voiceManageDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      custom-class="voice-manage-dialog">
      <div class="voice-manage-content">
        <el-form :model="voiceForm" label-width="100px">
          <el-form-item label="创建方式">
            <el-radio-group v-model="voiceCreateType">
              <el-radio label="clone">声音复刻</el-radio>
              <el-radio label="design">声音设计</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="音色名称">
            <el-input v-model="newVoiceName" placeholder="请输入音色名称" maxlength="20"></el-input>
          </el-form-item>
          
          <!-- 声音复刻 -->
          <template v-if="voiceCreateType === 'clone'">
            <el-form-item label="音频文件">
              <el-upload
                class="voice-upload"
                action="#"
                :auto-upload="false"
                :on-change="handleVoiceFileChange"
                :file-list="voiceFileList"
                :limit="1"
                accept="audio/*"
                drag>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将音频文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持mp3、wav等音频格式，建议时长10-30秒</div>
              </el-upload>
            </el-form-item>
          </template>
          
          <!-- 声音设计 -->
          <template v-else>
            <el-form-item label="声音描述">
              <el-input 
                v-model="voicePrompt" 
                type="textarea" 
                :rows="3"
                placeholder="描述期望的音色特征，如：沉稳的中年男性播音员，音色低沉浑厚，富有磁性，语速平稳，吐字清晰"
                maxlength="200"
                show-word-limit>
              </el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="voiceManageDialogVisible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="handleGenerateVoice"
          :loading="voiceGenerating"
          :disabled="!canGenerateVoice">
          生成音色
        </el-button>
      </span>
    </el-dialog>
    
  </div>
</template>
<script>
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    import EUY from '@/common/scripts/euy'
    export default {
        // 组件
        components: {
        },
        // 计算
        computed: {
            // 选中的字幕数量
            selectedSubtitlesCount() {
                return this.currentPageSubtitles.filter(item => item.selected).length;
            },
            // 是否可以生成音色
            canGenerateVoice() {
                if (!this.newVoiceName) {
                    return false;
                }
                if (this.voiceCreateType === 'clone') {
                    return !!this.voiceUploadFile;
                } else {
                    return !!this.voicePrompt;
                }
            }
        },
        data () {
            return {
                init: '',
                more: true,
                current_page: 1,
                page_size: 20,
                proto_subtitles: [],
                proto_bubble: [],
                form_subtitles: {
                    font_family_options: [],
                    font_family: '',
                    font_size_options: [],
                    font_size: '',
                    color: '',
                    halign: '',
                    content: '',
                },
                form_bubble: {
                    font_family_options: [],
                    font_family: '',
                    font_size_options: [],
                    font_size: '',
                    color: '',
                    halign: '',
                    content: '',
                },
                bubble_data: [],
                tabs_data: [
                    { name: '底部字幕', active: true },
                    { name: '气泡文字', active: false }
                ],
                halign_data: [
                    { class: 'icon-text_left', active: false },
                    { class: 'icon-text_mediate', active: true },
                    { class: 'icon-text_right', active: false },
                ],
                type: '',
                mask_visible: true,
                tip_visible: false,
                // -------------------------------------------------- [ TTS 相关数据 ] --------------------------------------------------
                // 当前页字幕列表
                currentPageSubtitles: [],
                // 当前选中的步骤索引
                currentStepIndex: -1,
                // 全选状态
                selectAll: false,
                // TTS 全局配置
                tts_global_config: {
                    speed: 1.0,        // 语速0.5到2.0  后端接口传入 -500 到 500
                    volume: 50,      // 音量 0 到 100
                    pitch: 1.0,        // 音调0.5到2.0    后端接口传入 -500 到 500
                    voice: '', // 音色
                    emotion: '', // 情感
                },
                // 音色列表
                voice_list: [],
                voice_list_loading: false,
                // 我的音色列表
                my_voice_list: [],
                my_voice_loading: false,
                // 团队音色列表
                team_voice_list: [],
                team_voice_loading: false,
                team_id: '',
                team_name: '',
                user_id: '', // 当前用户ID
                // 音色选择器状态
                voicePopoverVisible: false,
                voiceTabActive: 'public', // 'team', 'public' 或 'my'
                // 当前音色支持的情感列表
                current_voice_emotions: [],
                // 音色管理对话框
                voiceManageDialogVisible: false,
                voiceCreateType: 'clone', // 'clone' 或 'design'
                voiceUploadFile: null,
                voiceFileList: [],
                voiceGenerating: false,
                newVoiceName: '',
                voicePrompt: '', // 声音设计提示词
                previewText: '各位听众朋友，大家好，欢迎收听晚间新闻', // 预览文本默认值
                voiceForm: {},
                // TTS 生成状态
                tts_generating: false,
                tts_status_message: '',
                tts_status_icon: '',
                // 生成的音频
                hasGeneratedAudio: false,
                generatedAudioUrl: '',
                generatedAudioId: '',  // 生成的音频ID
                generatedSentences: [], // 生成的句子列表
                // -------------------------------------------------- [ 口型匹配相关数据 ] --------------------------------------------------
                // 口型匹配配置
                lip_sync_config: {
                    bundleAlias: '',     // 形象别名
                    emotion: 1,          // 表情 1-8
                    emotionLevel: 0,     // 表情等级 0-7
                    autoGenerate: false, // 是否自动生成口型
                },
                // 形象列表
                bundle_list: [],
                bundle_list_loading: false,
                bundle_res_cache: {}, // 形象资源缓存 (id -> {thumb, name})
                // 口型表情列表（1-8对应图标）
                lip_sync_emotions: [
                    { label: '平静', value: 1, icon: require('./1.png') },
                    { label: '喜', value: 2, icon: require('./2.png') },
                    { label: '怒', value: 3, icon: require('./3.png') },
                    { label: '悲', value: 4, icon: require('./4.png') },
                    { label: '恐', value: 5, icon: require('./5.png') },
                    { label: '囧', value: 6, icon: require('./6.png') },
                    { label: '嫌弃', value: 7, icon: require('./7.png') },
                    { label: '色', value: 8, icon: require('./8.png') },
                ],
                // 口型生成状态
                lip_sync_generating: false,
                // 形象TTS参数记录 (bundleId -> {voice, emotion, speed, pitch})
                bundleTtsSettings: {},
                // -------------------------------------------------- [ FLASH ] --------------------------------------------------
                has_token: '',
                // 遮罩层
                mask_visible_: true,

            }
        },
        methods: {
            handleMore() {
                this.current_page += 1;
                this.handleGetCategoryListDate();
            },

            handleSubtitlesFontFamilyChange(value) {
                this.form_subtitles.font_family = value
                this.handleAllChange()
            },

            handleBubbleFontFamilyChange(value) {
                this.form_bubble.font_family = value
                this.handleAllChange()
            },

            handleSubtitlesFontFizeChange(value) {
                this.form_subtitles.font_fize = value
                this.handleAllChange()
            },

            handleBubbleFontSizeChange(value) {
                this.form_bubble.font_fize = value
                this.handleAllChange()
            },

            handleSubtitlesColorChange(value) {
                this.form_subtitles.color = value
                this.handleAllChange()
            },

            handleBubbleColorChange(value) {
                this.form_bubble.color = value
                this.handleAllChange()
            },

            handleSubtitlesChange (value) {
                if (value.length > 512) {
                    this.tip_visible = true
                } else {
                    this.tip_visible = false
                }
                this.form_subtitles.content = value
                this.handleAllChange()
            },

            handleBubbleChange (value) {
                this.form_bubble.content = value
                this.handleAllChange()
            },

            handleAllChange () {
                let  platform = this.$route.query.platform
                if (this.type == 0) {
                    if (this.form_subtitles.content == this.proto_subtitles[1] &&
                        this.form_subtitles.font_size == this.proto_subtitles[2] &&
                        this.form_subtitles.font_family == this.proto_subtitles[3] &&
                        this.form_subtitles.color == this.proto_subtitles[4] &&
                        this.form_subtitles.halign == this.proto_subtitles[5]) {
                        return false
                    }
                    // protobuf 打包
                    let MMaterial  = new proto.com.proto.scene.MText()
                    // protobuf 打包格式
                    MMaterial.setEnable('0')
                    MMaterial.setText(this.form_subtitles.content)
                    MMaterial.setSize(this.form_subtitles.font_size)
                    MMaterial.setFont(this.form_subtitles.font_family)
                    MMaterial.setColor(this.form_subtitles.color)
                    MMaterial.setHalign(this.form_subtitles.halign)
                    // protobuf 序列化
                    let protoBytes = MMaterial.serializeBinary()
                    // Uint8Array 转换 Array
                    let protoBytesArray = Array.from(protoBytes)
                    let text_scene_6_10 = {
                        packageId: 0,
                        senderId: TEXT,
                        senderName: TEXT_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 10,
                        protoBytesType: 'proto.com.proto.scene.MText',
                        protoBytes: protoBytesArray
                    }
                    // 发送消息
                    Protocol.sender(platform, text_scene_6_10)
                }
                if (this.type == 1) {
                    if (this.form_bubble.content == this.proto_bubble[1] &&
                        this.form_bubble.font_family == this.proto_bubble[3] &&
                        this.proto_bubble.color == this.proto_bubble[4]) {
                        return false
                    }
                    // protobuf 打包
                    let MMaterial  = new proto.com.proto.scene.MText()
                    // protobuf 打包格式
                    MMaterial.setEnable('1')
                    MMaterial.setText(this.form_bubble.content)
                    MMaterial.setFont(this.form_bubble.font_family)
                    MMaterial.setColor(this.form_bubble.color)
                    // protobuf 序列化
                    let protoBytes = MMaterial.serializeBinary()
                    // Uint8Array 转换 Array
                    let protoBytesArray = Array.from(protoBytes)
                    let text_scene_6_11 = {
                        packageId: 0,
                        senderId: TEXT,
                        senderName: TEXT_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 11,
                        protoBytesType: 'proto.com.proto.scene.MText',
                        protoBytes: protoBytesArray
                    }
                    // 发送消息
                    Protocol.sender(platform, text_scene_6_11)
                }
            },

            handleBubbleAdd (ori_data_id) {
                let  platform = this.$route.query.platform
                // protobuf 打包
                let MMaterial  = new proto.com.proto.material.MMaterial()
                // protobuf 打包格式
                MMaterial.setType('bubble')
                MMaterial.setId(ori_data_id)
                // protobuf 序列化
                let protoBytes = MMaterial.serializeBinary()
                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes)
                let text_scene_3_1 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 3,
                    messageId: 1,
                    protoBytesType: 'proto.com.proto.material.MMaterial',
                    protoBytes: protoBytesArray
                }
                // 发送消息
                Protocol.sender(platform, text_scene_3_1)
            },

            handleTabsChange(index, data) {
                if (index == 0) {
                    this.type = 0
                }
                if (index == 1) {
                    this.type = 1
                    // this.handleGetCategoryListDate()
                }
                this.changeTab(index, data)
            },
            changeTab(index, data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].active = false
                }
                data[index].active = true
            },
            // 素材分类列表
            handleGetCategoryListDate () {
                let URL = process.env.HOST + '/api/storage/market/matters'
                let headers = {
                    'Authorization': EUY.GetStorage('login_status').tokenId
                }
                let params = {
                    'type': 'bubble',
                    'pageSize': this.page_size,
                    'page': this.current_page,
                }
                this.AJAX.get(URL, headers, params).then((data)=>{
                    if(data.datas.rows) {
                        this.bubble_data = this.bubble_data.concat(data.datas.rows);
                        if(data.datas.rows.length < this.page_size) {
                            this.more = false;
                        }
                    }else {
                        this.more = false;
                    }
                }).catch((err)=>{
                    this.$message({
                        message: "bubble list-" + err.msg||err.message,
                        type: 'error'
                    })
                })
            },

            fontSizeInit(start, end) {
                for (let i = 0; i <= (end - 10); i++) {
                    let num = start + i
                    this.form_subtitles.font_size_options.push({ label: num, value: num })
                    this.form_bubble.font_size_options.push({ label: num, value: num })
                }
            },



            handleSubtitlesHalignChange (index, data) {
                if (index == 0) {
                    this.form_subtitles.halign = 'left'
                }
                if (index == 1) {
                    this.form_subtitles.halign = 'center'
                }
                if (index == 2) {
                    this.form_subtitles.halign = 'right'
                }
                if (this.form_subtitles.font_family == undefined) {
                    this.form_subtitles.font_family = 'undefined'
                }
                this.changeTab(index, data)
                this.handleAllChange(this.form_subtitles.content, this.form_subtitles.font_size, this.form_subtitles.font_family, this.form_subtitles.color, this.form_subtitles.halign)
            },

            changeTab(index, data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].active = false
                }
                data[index].active = true
            },

            // -------------------------------------------------- [ TTS 相关方法 ] --------------------------------------------------
            
            // 初始化当前页字幕列表（模拟数据，实际应从动画引擎获取）
            initCurrentPageSubtitles() {
                // TODO: 从动画引擎获取当前页的所有步骤字幕
                // 这里先用模拟数据
                this.currentPageSubtitles = [
                    {
                        stepIndex: 0,
                        text: '',
                        voice: 'zhifeng_emo',
                        emotion: 'angry',
                        selected: false,
                        audioUrl: ''
                    }
                ];
            },

            // 点击步骤，定位到对应字幕
            handleStepClick(index) {
                this.currentStepIndex = index;
                // 滚动到对应的字幕项
                this.$nextTick(() => {
                    const listContent = document.querySelector('.subtitles-list-content');
                    const activeItem = document.querySelectorAll('.subtitle-item')[index];
                    if (listContent && activeItem) {
                        activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                });
                // TODO: 通知动画引擎跳转到对应步骤
            },

            // 全选/取消全选
            handleSelectAll(val) {
                this.currentPageSubtitles.forEach(item => {
                    item.selected = val;
                });
            },

            // 单个选择
            handleItemSelect(index) {
                // 检查是否全部选中
                this.selectAll = this.currentPageSubtitles.every(item => item.selected);
            },

            // 字幕文本变化
            handleSubtitleTextChange(index) {
                // TODO: 同步到动画引擎
            },

            // 获取音色列表
            async loadVoiceList() {
                this.voice_list_loading = true;
                try {
                    const platform = this.$route.query.platform;
                    const URL = process.env.HOST + '/api/storage/tts/voices';
                    const headers = {
                        'Authorization': EUY.GetStorage('login_status').tokenId
                    };
                    const params = {
                        voiceType: 1, // 只获取系统预置音色
                        status: 1     // 只获取可用音色
                    };
                    
                    this.AJAX.get(URL, headers, params).then((data)=>{
                        this.voice_list = data.datas;
                        // 设置默认音色
                        if (this.voice_list.length > 0 && !this.tts_global_config.voice) {
                            this.tts_global_config.voice = this.voice_list[0].voiceId;
                        }
                        // 更新当前音色的情感列表
                        this.updateEmotionList();
                    }).catch((err)=>{
                            this.$message({
                                message: "bubble list-" + err.msg||err.message,
                                type: 'error'
                            });
                        });
                } catch (error) {
                    console.error('获取音色列表失败:', error);
                    this.$message.error('获取音色列表失败');
                } finally {
                    this.voice_list_loading = false;
                }
            },

            // 更新情感列表
            updateEmotionList() {
                const currentVoice = this.voice_list.find(v => v.voiceId === this.tts_global_config.voice);
                if (!currentVoice) {
                    this.current_voice_emotions = [];
                    this.tts_global_config.emotion = '';
                    return;
                }

                // 情感映射
                const emotionMap = {
                    'neutral': '平静',
                    'happy': '开心',
                    'sad': '悲伤',
                    'angry': '愤怒',
                    'fear': '害怕',
                    'hate': '憎恨',
                    'surprise': '惊讶',
                    'arousal': '激动',
                    'serious': '严肃',
                    'disgust': '厌恶',
                    'jealousy': '嫉妒',
                    'embarrassed': '尴尬',
                    'frustrated': '沮丧',
                    'affectionate': '深情',
                    'gentle': '温柔',
                    'newscast': '播报',
                    'customer-service': '客服',
                    'story': '小说',
                    'living': '直播'
                };

                // 优先使用 emotionVariants（后端已将 support_emotions 转换为 emotionVariants）
                if (currentVoice.emotionVariants && currentVoice.emotionVariants.length > 0) {
                    this.current_voice_emotions = currentVoice.emotionVariants.map(variant => ({
                        value: variant.emotionTag,
                        label: emotionMap[variant.emotionTag] || variant.emotionTag
                    }));

                    // 如果当前情感不在支持列表中，重置为第一个
                    if (this.current_voice_emotions.length > 0) {
                        const hasCurrentEmotion = this.current_voice_emotions.some(
                            e => e.value === this.tts_global_config.emotion
                        );
                        if (!hasCurrentEmotion) {
                            this.tts_global_config.emotion = this.current_voice_emotions[0].value;
                        }
                    }
                } else if (currentVoice.supportEmotions && currentVoice.supportEmotions.length > 0) {
                    // 兼容旧版本的 supportEmotions 字段
                    this.current_voice_emotions = currentVoice.supportEmotions.map(emotion => ({
                        value: emotion,
                        label: emotionMap[emotion] || emotion
                    }));

                    if (this.current_voice_emotions.length > 0) {
                        const hasCurrentEmotion = this.current_voice_emotions.some(
                            e => e.value === this.tts_global_config.emotion
                        );
                        if (!hasCurrentEmotion) {
                            this.tts_global_config.emotion = this.current_voice_emotions[0].value;
                        }
                    }
                } else {
                    // 无情感支持
                    this.current_voice_emotions = [];
                    this.tts_global_config.emotion = '';
                }
            },

            // 获取选中的音色名称
            getSelectedVoiceName() {
                if (!this.tts_global_config.voice) {
                    return '选择音色';
                }
                const voiceId = this.tts_global_config.voice;
                const emotion = this.tts_global_config.emotion;

                // 先在团队音色中查找
                const teamVoice = this.team_voice_list.find(v => v.voiceId === voiceId);
                if (teamVoice) {
                    return teamVoice.voiceName;
                }

                // 再在公共音色中查找
                const publicVoice = this.voice_list.find(v => v.voiceId === voiceId);
                if (publicVoice) {
                    return publicVoice.voiceName;
                }

                // 最后在我的音色中查找
                const myVoice = this.my_voice_list.find(v => v.voiceId === voiceId);
                if (myVoice) {
                    return myVoice.voiceName;
                }

                return '选择音色';
            },

            // 点击音色项
            handleVoiceClick(voice) {
                this.selectVoice(voice.voiceId);
            },

            // 判断音色是否被选中
            isVoiceSelected(voice) {
                return this.tts_global_config.voice === voice.voiceId;
            },

            // 选择音色
            selectVoice(voiceId) {
                this.tts_global_config.voice = voiceId;
                this.voicePopoverVisible = false;
                this.handleVoiceChange();
            },

            // 打开音色管理对话框
            openMyVoiceManageDialog() {
                // 检查音色数量限制（最多10个）
                if (this.my_voice_list.length >= 10) {
                    this.$message.warning('音色数量已达上限（最多10个），请删除不需要的音色后再创建');
                    return;
                }
                this.voicePopoverVisible = false;
                this.voiceManageDialogVisible = true;
                this.voiceCreateType = 'clone';
                this.newVoiceName = '';
                this.voiceUploadFile = null;
                this.voiceFileList = [];
                this.voicePrompt = '';
                this.previewText = '各位听众朋友，大家好，欢迎收听晚间新闻';
            },

            // 打开音色管理对话框
            openTeamVoiceManageDialog() {
                // 检查音色数量限制（最多10个）
                if (this.team_voice_list.length >= 10) {
                    this.$message.warning('音色数量已达上限（最多10个），请删除不需要的音色后再创建');
                    return;
                }
                this.voicePopoverVisible = false;
                this.voiceManageDialogVisible = true;
                this.voiceCreateType = 'clone';
                this.newVoiceName = '';
                this.voiceUploadFile = null;
                this.voiceFileList = [];
                this.voicePrompt = '';
                this.previewText = '各位听众朋友，大家好，欢迎收听晚间新闻';
            },

            // 处理音频文件选择
            handleVoiceFileChange(file, fileList) {
                this.voiceUploadFile = file.raw;
                this.voiceFileList = fileList;
            },

            // 生成音色
            async handleGenerateVoice() {
                if (!this.newVoiceName) {
                    this.$message.warning('请输入音色名称');
                    return;
                }
                
                const isVoiceDesign = this.voiceCreateType === 'design';
                
                if (!isVoiceDesign && !this.voiceUploadFile) {
                    this.$message.warning('请上传音频文件');
                    return;
                }
                
                if (isVoiceDesign && !this.voicePrompt) {
                    this.$message.warning('请输入声音描述');
                    return;
                }

                // 检查音色数量限制（最多10个）
                if (this.team_id) {
                    if (this.team_voice_list.length >= 10) {
                        this.$message.warning('音色数量已达上限（最多10个），请删除不需要的音色后再创建');
                        return;
                    }
                } else {
                    if (this.my_voice_list.length >= 10) {
                        this.$message.warning('音色数量已达上限（最多10个），请删除不需要的音色后再创建');
                        return;
                    }
                }

                this.voiceGenerating = true;

                try {
                    const platform = this.$route.query.platform;
                    let audioUrl = null;
                    
                    // 声音复刻：需要上传音频文件
                    if (!isVoiceDesign) {
                        const formData = new FormData();
                        formData.append('file', this.voiceUploadFile);
                        formData.append('type', 'none');
                        if (this.team_id) {
                            formData.append('ownerId', this.team_id);
                        }
                        
                        const uploadUrl = process.env.HOST + '/api/storage/storage/upload';
                        const uploadHeaders = {
                            'Authorization': EUY.GetStorage('login_status').tokenId
                        };
                        
                        const uploadResponse = await this.AJAX.post(uploadUrl, uploadHeaders, formData, {noAuthRedirect: true});
                        
                        if (!uploadResponse || uploadResponse.code !== 10000 || !uploadResponse.datas || !uploadResponse.datas.url) {
                            throw new Error('音频文件上传失败');
                        }
                        
                        audioUrl = uploadResponse.datas.url;
                    }

                    // 调用声音复刻/设计API
                    let cloneUrl = process.env.HOST + '/api/storage/tts/voice/clone';
                    // 将 teamId 作为 URL 参数传递
                    if (this.team_id) {
                        cloneUrl += '?teamId=' + encodeURIComponent(this.team_id);
                    }
                    
                    const cloneHeaders = {
                        'Authorization': EUY.GetStorage('login_status').tokenId,
                        'Content-Type': 'application/json'
                    };
                    
                    const cloneParams = {
                        voiceName: this.newVoiceName,
                        description: isVoiceDesign ? '用户设计音色' : '用户复刻音色',
                    };
                    
                    // 声音设计参数
                    if (isVoiceDesign) {
                        cloneParams.voicePrompt = this.voicePrompt;
                        cloneParams.previewText = this.previewText;
                        cloneParams.targetModel = 'cosyvoice-v3.5-plus';
                    } else {
                        // 声音复刻参数
                        cloneParams.audioUrl = audioUrl;
                        cloneParams.targetModel = 'cosyvoice-v3-flash';
                    }
                    
                    const cloneResponse = await this.AJAX.post(cloneUrl, cloneHeaders, JSON.stringify(cloneParams), {noAuthRedirect: true});
                    
                    if (!cloneResponse || cloneResponse.code !== 10000 || !cloneResponse.datas) {
                        throw new Error((cloneResponse && cloneResponse.message) || '声音复刻失败');
                    }

                    this.$message.success('音色复刻成功！');
                    
                    // 将新创建的音色添加到列表
                    const newVoice = {
                        voiceId: cloneResponse.datas.voiceId,
                        voiceName: this.newVoiceName,
                        voiceType: 2,
                        status: cloneResponse.datas.status || 0,
                        targetModel: cloneParams.targetModel,
                        expirationTime: cloneResponse.datas.expirationTime,
                        creatorId: this.user_id
                    };
                    
                    // 关闭音色管理对话框
                    this.voiceManageDialogVisible = false;
                    
                    // 添加到对应的音色列表并切换tab
                    if (this.team_id) {
                        this.voiceTabActive = 'team';
                        this.team_voice_list.unshift(newVoice);
                        // 重新加载团队音色列表以获取最新状态
                        await this.loadTeamVoiceList();
                    } else {
                        this.voiceTabActive = 'my';
                        this.my_voice_list.unshift(newVoice);
                        // 重新加载我的音色列表以获取最新状态
                        await this.loadMyVoiceList();
                    }
                } catch (error) {
                    console.error('生成音色失败:', error);
                    this.$message.error('生成音色失败：' + (error.message || '请重试'));
                } finally {
                    this.voiceGenerating = false;
                }
            },

            // 删除我的音色
            deleteMyVoice(voiceId) {
                this.$confirm('确定要删除这个音色吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        const platform = this.$route.query.platform;
                        const deleteUrl = process.env.HOST + '/api/storage/tts/voice/cloned/' + voiceId;
                        const headers = {
                            'Authorization': EUY.GetStorage('login_status').tokenId
                        };
                        
                        await this.AJAX.delete(deleteUrl, headers, null, {noAuthRedirect: true});

                        // 从列表中移除
                        const index = this.my_voice_list.findIndex(v => v.voiceId === voiceId);
                        if (index > -1) {
                            this.my_voice_list.splice(index, 1);
                        }

                        // 如果删除的是当前选中的音色，清空选择
                        if (this.tts_global_config.voice === voiceId) {
                            this.tts_global_config.voice = '';
                        }

                        this.$message.success('删除成功');
                    } catch (error) {
                        console.error('删除音色失败:', error);
                        this.$message.error('删除失败：' + (error.message || '请重试'));
                    }
                }).catch(() => {
                    // 取消删除
                });
            },

            // 加载我的音色列表
            async loadMyVoiceList() {
                this.my_voice_loading = true;
                try {
                    const platform = this.$route.query.platform;
                    const url = process.env.HOST + '/api/storage/tts/voices';
                    const headers = {
                        'Authorization': EUY.GetStorage('login_status').tokenId
                    };
                    
                    // 只获取用户复刻的音色（voiceType=2）
                    const params = {
                        voiceType: 2,
                        status: 1
                    };
                    
                    const response = await this.AJAX.get(url, headers, params, {noAuthRedirect: true});
                    
                    if (response && response.code === 10000 && response.datas) {
                        this.my_voice_list = response.datas.map(voice => ({
                            voiceId: voice.voiceId,
                            voiceName: voice.voiceName,
                            voiceType: voice.voiceType,
                            status: voice.status,
                            targetModel: voice.targetModel,
                            expirationTime: voice.expirationTime,
                            canDeleted: voice.canDeleted,
                            emotionVariants: voice.emotionVariants || []
                        }));
                    } else {
                        this.my_voice_list = [];
                    }
                    
                } catch (error) {
                    console.error('加载我的音色列表失败:', error);
                    this.my_voice_list = [];
                } finally {
                    this.my_voice_loading = false;
                }
            },

            // 加载团队音色列表
            async loadTeamVoiceList() {
                if (!this.team_id) {
                    this.team_voice_list = [];
                    return;
                }
                
                this.team_voice_loading = true;
                try {
                    const platform = this.$route.query.platform;
                    const url = process.env.HOST + '/api/storage/tts/voices';
                    const headers = {
                        'Authorization': EUY.GetStorage('login_status').tokenId
                    };
                    
                    // 获取团队的复刻音色（voiceType=2）
                    const params = {
                        voiceType: 2,
                        status: 1,
                        teamId: this.team_id
                    };
                    
                    const response = await this.AJAX.get(url, headers, params, {noAuthRedirect: true});
                    
                    if (response && response.code === 10000 && response.datas) {
                        this.team_voice_list = response.datas.map(voice => ({
                            voiceId: voice.voiceId,
                            voiceName: voice.voiceName,
                            voiceType: voice.voiceType,
                            status: voice.status,
                            targetModel: voice.targetModel,
                            expirationTime: voice.expirationTime,
                            canDeleted: voice.canDeleted,
                            emotionVariants: voice.emotionVariants || []
                        }));
                    } else {
                        this.team_voice_list = [];
                    }
                    
                } catch (error) {
                    console.error('加载团队音色列表失败:', error);
                    this.team_voice_list = [];
                } finally {
                    this.team_voice_loading = false;
                }
            },

            // 删除团队音色
            deleteTeamVoice(voiceId) {
                this.$confirm('确定要删除这个音色吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        const platform = this.$route.query.platform;
                        const deleteUrl = process.env.HOST + '/api/storage/tts/voice/cloned/' + voiceId;
                        const headers = {
                            'Authorization': EUY.GetStorage('login_status').tokenId
                        };
                        
                        await this.AJAX.delete(deleteUrl, headers, null, {noAuthRedirect: true});

                        // 从列表中移除
                        const index = this.team_voice_list.findIndex(v => v.voiceId === voiceId);
                        if (index > -1) {
                            this.team_voice_list.splice(index, 1);
                        }

                        // 如果删除的是当前选中的音色，清空选择
                        if (this.tts_global_config.voice === voiceId) {
                            this.tts_global_config.voice = '';
                        }

                        this.$message.success('删除成功');
                    } catch (error) {
                        console.error('删除音色失败:', error);
                        this.$message.error('删除失败：' + (error.message || '请重试'));
                    }
                }).catch(() => {
                    // 取消删除
                });
            },

            // 音色变化
            handleVoiceChange() {
                this.updateEmotionList();
                this.invalidateGeneratedAudio();
            },

            // 情感变化
            handleEmotionChange() {
                this.invalidateGeneratedAudio();
            },

            // 语速/音量/音调滑块变化
            handleTtsParamChange() {
                this.invalidateGeneratedAudio();
            },

            // TTS参数（音色/情感/语速/音量/音调）变化后，已生成的音频仍按旧参数合成，
            // 置为失效，避免试听或添加到时间轴的仍是旧参数的音频
            invalidateGeneratedAudio() {
                if (!this.hasGeneratedAudio && !this.generatedAudioUrl) {
                    return;
                }
                this.hasGeneratedAudio = false;
                this.generatedAudioUrl = '';
                this.generatedAudioId = '';
                this.generatedSentences = [];
                this.tts_status_message = '语音参数已修改，请重新生成语音';
                this.tts_status_icon = 'el-icon-warning';
            },
            
            // 格式化过期时间
            formatExpirationTime(timestamp) {
                if (!timestamp) return '';
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },

            // -------------------------------------------------- [ 口型匹配相关方法 ] --------------------------------------------------
            
            // 请求步信息（包含形象列表）
            requestStepDetails() {
                // 发送请求步信息的消息 (6, 2)
                const platform = this.$route.query.platform;
                const text_scene_6_2 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 2,
                    protoBytesType: '',
                    protoBytes: []
                };
                Protocol.sender(platform, text_scene_6_2);
            },

            // 形象变化
            handleCharacterChange() {
                
                // 根据选中的形象自动带出对应的TTS参数
                this.loadTtsSettingsForCharacter();
            },

            // 为选中形象加载TTS参数设置
            loadTtsSettingsForCharacter() {
                if (!this.lip_sync_config.bundleAlias) {
                    return;
                }
                
                // 根据bundleAlias找到对应的bundle.id
                const selectedBundle = this.bundle_list.find(bundle => bundle.alias === this.lip_sync_config.bundleAlias);
                if (!selectedBundle) {
                    return;
                }
                
                const bundleId = selectedBundle.id;
                const savedSettings = this.bundleTtsSettings[bundleId];
                
                if (savedSettings) {
                    // 恢复保存的TTS参数
                    this.tts_global_config.voice = savedSettings.voice || this.tts_global_config.voice;
                    this.tts_global_config.emotion = savedSettings.emotion || this.tts_global_config.emotion;
                    this.tts_global_config.speed = savedSettings.speed || this.tts_global_config.speed;
                    this.tts_global_config.pitch = savedSettings.pitch || this.tts_global_config.pitch;
                    
                    // 更新情感列表（因为音色可能变了）
                    this.updateEmotionList();
                    // 参数被形象记忆恢复覆盖，已生成音频可能不再匹配
                    this.invalidateGeneratedAudio();
                } else {
                }
            },

            // 保存当前形象的TTS参数设置
            saveTtsSettingsForCharacter() {
                if (!this.lip_sync_config.bundleAlias) {
                    return;
                }
                
                // 根据bundleAlias找到对应的bundle.id
                const selectedBundle = this.bundle_list.find(bundle => bundle.alias === this.lip_sync_config.bundleAlias);
                if (!selectedBundle) {
                    return;
                }
                
                const bundleId = selectedBundle.id;
                const currentSettings = {
                    voice: this.tts_global_config.voice,
                    emotion: this.tts_global_config.emotion,
                    speed: this.tts_global_config.speed,
                    pitch: this.tts_global_config.pitch
                };
                
                this.bundleTtsSettings[bundleId] = currentSettings;
            },

            // 口型情感变化
            handleLipSyncEmotionChange() {
                // 如果勾选了自动生成，则自动生成口型
                this.autoGenerateLipSyncIfNeeded();
            },

            // 表情等级变化
            handleEmotionLevelChange() {
                // 如果勾选了自动生成，则自动生成口型
                this.autoGenerateLipSyncIfNeeded();
            },

            // 自动生成口型（如果满足条件）
            autoGenerateLipSyncIfNeeded() {
                if (this.lip_sync_config.autoGenerate && 
                    this.generatedSentences.length > 0 && 
                    this.lip_sync_config.bundleAlias) {
                    this.handleGenerateLipSync();
                }
            },

            // 生成口型
            async handleGenerateLipSync() {
                let platform = this.$route.query.platform;
                if (!this.lip_sync_config.bundleAlias) {
                    this.$message.warning('请选择形象');
                    return;
                }

                if (this.generatedSentences.length === 0) {
                    this.$message.warning('请先生成语音，获取时间戳数据');
                    return;
                }

                this.lip_sync_generating = true;

                try {
                    // 保存当前形象的TTS参数设置
                    this.saveTtsSettingsForCharacter();
                    
                    // 计算表情索引 (moodIndex)
                    const moodIndex = this.calculateMoodIndex();
                    
                    // 构建口型数据
                    const lipSyncData = {
                        bundleAlias: this.lip_sync_config.bundleAlias, // 形象别名
                        moodIndex: moodIndex,                        // 表情索引
                        sentences: this.generatedSentences        // 句子时间戳数据
                    };

                    // 序列化为 JSON 字符串
                    const jsonStr = JSON.stringify(lipSyncData);

                    let text_scene_6_55 = {
                            packageId: 0,
                            senderId: TEXT,
                            senderName: TEXT_NAME,
                            receiverId: SCENE,
                            receiverName: SCENE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 6,
                            messageId: 55,
                            protoBytesType: 'proto.com.proto.s.MString',
                            protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                                setValue: jsonStr,
                            })
                        }
                    Protocol.sender(platform, text_scene_6_55)
                    
                    this.$message.success('口型生成请求已发送');

                } catch (error) {
                    console.error('生成口型失败:', error);
                    this.$message.error('生成口型失败: ' + error.message);
                } finally {
                    this.lip_sync_generating = false;
                }
            },
            
            // 计算表情索引
            calculateMoodIndex() {
                // 表情索引映射：1-8 对应不同的表情基础索引
                // 每个表情有8个等级（0-7），通过 emotionLevel 调整
                const emotionBaseMap = {
                    1: 0,   // 表情1: 0-7
                    2: 8,  // 表情2: 8-15 (喜)
                    3: 16,  // 表情3: 16-23 (怒)
                    4: 24,  // 表情4: 24-31 (悲)
                    5: 32,  // 表情5: 32-39 (恐)
                    6: 40,  // 表情6: 40-47 (囧)
                    7: 48,  // 表情7: 48-55 (嫌弃)
                    8: 56   // 表情8: 56-63 (色)
                };
                
                const emotion = this.lip_sync_config.emotion || 1;
                const baseIndex = emotionBaseMap[emotion] || 0;
                const level = Math.min(Math.max(this.lip_sync_config.emotionLevel, 0), 7);
                
                return baseIndex + level;
            },

            // 接收口型生成结果
            onLipSyncGenerated(data) {
                this.$message.success('口型生成完成');
            },
            
            // 处理步信息，提取形象列表
            handleStepDetails(stepDetails) {
                // 保存当前选中的形象别名
                const currentBundleAlias = this.lip_sync_config.bundleAlias;
                
                this.bundle_list = [];
                // 提取形象列表 (msg.roles)
                const roles = stepDetails.rolesList || [];
                if (roles.length === 0) {
                    this.bundle_list = [];
                    this.lip_sync_config.bundleAlias = "";
                    return;
                }
                
                // 转换为下拉框数据格式
                this.bundle_list = roles.map(role => ({
                    id: role.id,      // 使用 alias 作为 ID
                    alias: role.alias,    // 显示名称
                    actions: role.actionsList || []
                }));
                
                // 检查当前选中的形象是否仍然存在于新的列表中
                const existingBundle = this.bundle_list.find(bundle => bundle.alias === currentBundleAlias);
                if (existingBundle) {
                    // 如果存在，保持选中状态
                    this.lip_sync_config.bundleAlias = currentBundleAlias;
                } else {
                    // 如果不存在，清空选择
                    this.lip_sync_config.bundleAlias = "";
                }
                
                // 提取所有形象的 ID，用于获取缩略图
                const bundleIds = roles.map(role => role.id).filter(id => id);
                
                if (bundleIds.length > 0) {
                    this.fetchBundleThumbnails(bundleIds);
                }
                
                // 设置默认选中第一个形象
                if (this.bundle_list.length > 0 && !this.lip_sync_config.bundleAlias) {
                    this.lip_sync_config.bundleAlias = this.bundle_list[0].alias;
                }
                
            },
            
            // 获取形象缩略图
            fetchBundleThumbnails(bundleIds) {
                // 检查缓存，只请求未缓存的 ID
                const uncachedIds = bundleIds.filter(id => !this.bundle_res_cache[id]);
                
                if (uncachedIds.length === 0) {
                    return;
                }
                
                const URL = process.env.HOST + '/pro/api/matter/listByIds';
                const params = 'id=' + uncachedIds.toString();
                const headers = {
                    'token': EUY.GetStorage('login_status').tokenId,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                };
                
                this.AJAX.post(URL, headers, params).then((data) => {
                    if (data.result) {
                        // 缓存结果 - 使用 $set 确保 Vue 响应式更新
                        for (const id in data.result) {
                            this.$set(this.bundle_res_cache, id, {
                                thumb: data.result[id].thumb,
                                title: data.result[id].title
                            });
                        }
                        // 强制更新视图
                        this.$forceUpdate();
                    }
                }).catch((err) => {
                    console.error('获取形象缩略图失败:', err);
                });
            },
            
            // 获取形象缩略图 URL
            getBundleThumb(bundleId) {
                if (this.bundle_res_cache[bundleId]) {
                    return this.bundle_res_cache[bundleId].thumb;
                }
                return '';
            },

            //获取形象名称
            getBundleName(bundleId) {
                if (this.bundle_res_cache[bundleId]) {
                    return this.bundle_res_cache[bundleId].title;
                }
                return '';
            },

            // 生成单条 TTS 语音
            async handleGenerateTTS() {
                // 检查文本内容
                if (!this.form_subtitles.content || this.form_subtitles.content.trim() === '') {
                    this.$message.warning('请输入字幕文字');
                    return;
                }

                this.tts_generating = true;
                this.tts_status_message = '正在生成语音...';
                this.tts_status_icon = 'el-icon-loading';

                try {
                    const platform = this.$route.query.platform;
                    const URL = process.env.HOST + '/api/storage/tts/synthesize';
                    const headers = {
                        'Authorization': EUY.GetStorage('login_status').tokenId,
                        'Content-Type': 'application/json'
                    };
                    
                    // 转换语速和音调：前端 0.5-2.0 → 后端 -500-500
                    // 阿里云语速公式：
                    // 小于1倍速：(1 - 1/倍速) / 0.002
                    // 大于1倍速：(1 - 1/倍速) / 0.001
                    const speed = this.tts_global_config.speed || 1.0;
                    const pitch = this.tts_global_config.pitch || 1.0;
                    
                    let speechRate = 0;
                    if (speed < 1.0) {
                        speechRate = Math.round((1 - 1/speed) / 0.002);
                    } else if (speed > 1.0) {
                        speechRate = Math.round((1 - 1/speed) / 0.001);
                    }
                    
                    let pitchRate = 0;
                    if (pitch < 1.0) {
                        pitchRate = Math.round((1 - 1/pitch) / 0.002);
                    } else if (pitch > 1.0) {
                        pitchRate = Math.round((1 - 1/pitch) / 0.001);
                    }
                    
                    // 获取当前音色的targetModel
                    let targetModel = 'SpeechSynthesizer'; // 默认使用老版本
                    const currentVoice = this.voice_list.find(v => v.voiceId === this.tts_global_config.voice) ||
                                        this.team_voice_list.find(v => v.voiceId === this.tts_global_config.voice) || 
                                        this.my_voice_list.find(v => v.voiceId === this.tts_global_config.voice);
                    if (currentVoice && currentVoice.targetModel) {
                        targetModel = currentVoice.targetModel;
                    }
                    
                    // 构建请求参数
                    const requestData = {
                        text: this.form_subtitles.content,
                        voiceId: this.tts_global_config.voice || 'xiaoyun',
                        emotion: this.tts_global_config.emotion,
                        format: 'mp3',
                        sampleRate: 16000,
                        volume: this.tts_global_config.volume || 50,
                        speechRate: speechRate,
                        pitchRate: pitchRate,
                        targetModel: targetModel
                    };

                    // 调用单次合成接口
                    const response = await this.AJAX.post(URL, headers, JSON.stringify(requestData), {noAuthRedirect: true});
                    
                    if (response && response.datas) {
                        this.generatedAudioUrl = response.datas.audioUrl;
                        this.generatedAudioId = response.datas.audioId;  // 保存音频ID
                        this.generatedSentences = response.datas.sentences;
                        this.hasGeneratedAudio = true;
                        this.tts_status_message = '语音生成成功';
                        this.tts_status_icon = 'el-icon-success';
                        this.$message.success('语音生成成功');
                        
                        // 自动生成口型（如果满足条件）
                        this.autoGenerateLipSyncIfNeeded();
                    } else {
                        throw new Error('返回数据格式错误');
                    }

                } catch (error) {
                    console.error('TTS 生成失败:', error);
                    this.tts_status_message = '生成失败: ' + (error.message || '未知错误');
                    this.tts_status_icon = 'el-icon-error';
                    this.$message.error('语音生成失败');
                } finally {
                    this.tts_generating = false;
                    // 3秒后清除状态消息
                    setTimeout(() => {
                        this.tts_status_message = '';
                    }, 3000);
                }
            },
            // 批量生成 TTS 语音
            async handleGenerateBatchTTS() {
                const selectedItems = this.currentPageSubtitles.filter(item => item.selected);
                
                if (selectedItems.length === 0) {
                    this.$message.warning('请至少选择一个字幕');
                    return;
                }

                // 检查是否有空文本
                const emptyItems = selectedItems.filter(item => !item.text || item.text.trim() === '');
                if (emptyItems.length > 0) {
                    this.$message.warning('请填写所有选中字幕的文本内容');
                    return;
                }

                this.tts_generating = true;
                this.tts_status_message = '正在生成语音...';
                this.tts_status_icon = 'el-icon-loading';

                try {
                    // TODO: 调用 TTS API
                    // 批量生成语音
                    const tasks = selectedItems.map(item => {
                        return {
                            text: item.text,
                            voice: this.tts_global_config.voice,
                            emotion: this.tts_global_config.emotion,
                            speed: this.tts_global_config.speed,
                            volume: this.tts_global_config.volume,
                            pitch: this.tts_global_config.pitch
                        };
                    });

                    // 模拟 API 调用
                    const response = await this.callTTSAPI(tasks);
                    
                    // 更新音频 URL
                    selectedItems.forEach((item, index) => {
                        item.audioUrl = response.audioUrls[index];
                    });

                    this.hasGeneratedAudio = true;
                    this.tts_status_message = `成功生成 ${selectedItems.length} 个语音`;
                    this.tts_status_icon = 'el-icon-success';
                    
                    this.$message.success('语音生成成功');

                } catch (error) {
                    console.error('TTS 生成失败:', error);
                    this.tts_status_message = '生成失败: ' + error.message;
                    this.tts_status_icon = 'el-icon-error';
                    this.$message.error('语音生成失败');
                } finally {
                    this.tts_generating = false;
                    // 3秒后清除状态消息
                    setTimeout(() => {
                        this.tts_status_message = '';
                    }, 3000);
                }
            },
            // 调用 TTS API（需要实现）
            async callTTSAPI(tasks) {
                // TODO: 实际调用后端 TTS API
                // 参考 storage-service 的 TTS 接口
                
                const platform = this.$route.query.platform;
                const URL = process.env.HOST + '/api/storage/tts/batch';
                const headers = {
                    'Authorization': EUY.GetStorage('login_status').tokenId,
                    'Content-Type': 'application/json'
                };
                
                const params = {
                    tasks: tasks.map(task => ({
                        text: task.text,
                        voice: task.voice,
                        speed: task.speed,
                        volume: task.volume,
                        pitch: task.pitch,
                        emotion: task.emotion
                    }))
                };

                // 模拟延迟
                await new Promise(resolve => setTimeout(resolve, 2000));
                
                // 模拟返回数据
                return {
                    audioUrls: tasks.map((_, index) => `http://cdn.example.com/tts_${Date.now()}_${index}.mp3`)
                };

                // 实际调用代码（取消注释使用）:
                // return await this.AJAX.post(URL, headers, JSON.stringify(params), {noAuthRedirect: true});
            },

            // 试听语音
            handlePreviewTTS() {
                if (!this.hasGeneratedAudio || !this.generatedAudioUrl) {
                    this.$message.warning('请先生成语音');
                    return;
                }

                // 播放生成的音频（加时间戳避免浏览器/CDN缓存返回同URL的旧内容）
                const previewUrl = this.generatedAudioUrl +
                    (this.generatedAudioUrl.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now();
                const audio = new Audio(previewUrl);
                audio.play().catch(error => {
                    console.error('播放失败:', error);
                    this.$message.error('音频播放失败');
                });
            },

            // 添加到时间轴
            handleAddToTimeline(trackType = 'voice') {
                if (!this.hasGeneratedAudio || !this.generatedAudioUrl) {
                    this.$message.warning('请先生成语音');
                    return;
                }

                // 检查是否有audioId
                if (!this.generatedAudioId) {
                    this.$message.error('音频ID缺失，无法添加到时间轴');
                    return;
                }

                try {
                    // 根据选择的音轨类型添加到对应音轨
                    if (trackType === 'voice') {
                        this.handleSendMsgAddVoice(this.generatedAudioId);
                        // 如果勾选了自动生成口型，则自动调用生成口型
                        if (this.lip_sync_config.autoGenerate) {
                            // 延迟一下，让用户看到口型发送成功的提示
                            setTimeout(() => {
                                // 发送消息到Scene模块，添加到人声配音音轨
                                this.handleGenerateLipSync();
                            }, 500);
                        }
                        this.$message.success('已添加语音到配音音轨');
                    } else if (trackType === 'sound_effect') {
                        this.handleSendMsgAddNarration(this.generatedAudioId);
                        this.$message.success('已添加语音到旁白音轨');
                    }
                } catch (error) {
                    console.error('添加到时间轴失败:', error);
                    this.$message.error('添加到时间轴失败');
                }
            },

            // 发送消息---添加人声配音到音轨
            handleSendMsgAddVoice(audioId) {
                let platform = this.$route.query.platform;

                // 创建MMaterial消息
                let MMaterial = new proto.com.proto.material.MMaterial();
                
                // 设置类型为voice（人声配音）
                MMaterial.setType("voice");
                MMaterial.setId(audioId);

                // protobuf 序列化
                let protoBytes = MMaterial.serializeBinary();

                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes);

                // 构造消息包
                let voice_scene_3_1 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 3,
                    messageId: 1,
                    protoBytesType: "proto.com.proto.material.MMaterial",
                    protoBytes: protoBytesArray
                };

                // 发送消息
                Protocol.sender(platform, voice_scene_3_1);
            },

            // 发送消息---添加旁白到音轨
            handleSendMsgAddNarration(audioId) {
                let platform = this.$route.query.platform;

                // 创建MMaterial消息
                let MMaterial = new proto.com.proto.material.MMaterial();
                
                // 设置类型为sound_effect（旁白）
                MMaterial.setType("sound_effect");
                MMaterial.setId(audioId);

                // protobuf 序列化
                let protoBytes = MMaterial.serializeBinary();

                // Uint8Array 转换 Array
                let protoBytesArray = Array.from(protoBytes);

                // 构造消息包
                let narration_scene_3_1 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 3,
                    messageId: 1,
                    protoBytesType: "proto.com.proto.material.MMaterial",
                    protoBytes: protoBytesArray
                };

                // 发送消息
                Protocol.sender(platform, narration_scene_3_1);
            },
        },

        mounted () {
            let platform = this.$route.query.platform
            let _this = this
            
            // 初始化 TTS 字幕列表
            this.initCurrentPageSubtitles();
            
            // TEXT
            // 模块初始化
            Protocol.onSocketInit(platform, TEXT_NAME, TEXT)
            // 模块与服务器建立链接
            Protocol.onSocketConnect(platform, TEXT_NAME)
            // 模块与服务器建立链接
            Protocol.onSocketRegister(platform, TEXT_NAME, TEXT)
            window[TEXT_NAME].domReady = () => {
                let text_core_1_1 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 1,
                    protoBytesType: 'proto.com.proto.s.MToken',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, text_core_1_1)
                this.handleGetCategoryListDate()
                this.fontSizeInit(10, 60)
                // 加载音色列表
                this.loadVoiceList();
                // 加载我的音色列表
                this.loadMyVoiceList();
                // 请求步信息（包含形象列表）
                this.requestStepDetails();
                // 检查场景是否加载完成
                let text_scene_6_26 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 26,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, text_scene_6_26)
                let text_scene_6_4 = {
                    packageId: 0,
                    senderId: TEXT,
                    senderName: TEXT_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 4,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, text_scene_6_4)
            }
            // 接收消息
            Protocol.receiver(platform, TEXT_NAME)
            window[TEXT_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {
                if (sessionId == 2 && messageId == 5) {
                    let text_scene_6_8 = {
                        packageId: 0,
                        senderId: TEXT,
                        senderName: TEXT_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 8,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, text_scene_6_8)
                    let text_scene_6_12 = {
                        packageId: 0,
                        senderId: TEXT,
                        senderName: TEXT_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 12,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, text_scene_6_12)
                }else if (sessionId == 6 && messageId == 3) {
                    // 接收步信息 (SM6_3_SyncStepDetails)
                    let stepDetails = Protocol.deserializeBinary('proto.com.proto.scene.MStepDetails', protoBytes).toObject();
                    _this.handleStepDetails(stepDetails);
                }else if (sessionId == 6 && messageId == 1) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.scene.MSelected', protoBytes).array
                    if(arr[1].length>0 && arr[1] != undefined){
                       if (arr[1][0][1] == 'bubble') {
                        _this.type = 1
                        _this.tabs_data = [
                            { name: '底部字幕', active: false },
                            { name: '气泡文字', active: true }
                        ]
                        } 
                    }
                    let text_scene_6_12 = {
                        packageId: 0,
                        senderId: TEXT,
                        senderName: TEXT_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 12,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, text_scene_6_12)
                }else if (sessionId == 6 && messageId == 5) {
                    _this.init = 'complete'
                    _this.mask_visible_ = false
                    console.log('[' + TEXT_NAME + '][COMPLETE]')
                    // 场景加载完成，请求步信息（包含形象列表）
                    _this.requestStepDetails();
                    let text_scene_6_8 = {
                        packageId: 0,
                        senderId: TEXT,
                        senderName: TEXT_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 8,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, text_scene_6_8)
                }else if (sessionId == 6 && messageId == 9) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.scene.MText', protoBytes).array
                    if(Array.isArray(arr) && arr.length>5) {
                        _this.proto_subtitles = arr
                        _this.form_subtitles.content = arr[1]
                        _this.form_subtitles.font_size = arr[2]
                        _this.form_subtitles.font_family = arr[3]
                        _this.form_subtitles.color = arr[4]
                        _this.form_subtitles.halign = arr[5]
                    }
                }else if (sessionId == 6 && messageId == 13) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.scene.MText', protoBytes).array
                    if(Array.isArray(arr) && arr.length>4) {
                        _this.proto_bubble = arr
                        arr[0] == '1' ? _this.mask_visible = false : _this.mask_visible = true
                        _this.form_bubble.content = arr[1]
                        _this.form_bubble.font_family = arr[3]
                        _this.form_bubble.color = arr[4]
                    }
                }else if(sessionId == 1 && messageId == 2){
                    let is_token = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array
                    if(Array.isArray(is_token) && is_token.length>0) {
                        _this.has_token = is_token[0]
                    }
                }else if (sessionId == 1 && messageId == 4) { // 接收用户信息
                    let arr = Protocol.deserializeBinary('proto.com.proto.s.UserInfo', protoBytes).array
                    if (arr && arr[3] && arr[3][0]) {
                        _this.user_id = arr[3][0]
                    }
                }else if (sessionId == 1 && messageId == 12) { // changeTab
                    let arr = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).array
                    // 接收团队信息
                    if (arr[4]) {
                        _this.team_id = arr[4]
                        _this.team_name = arr[5]
                        // 切换到团队音色tab
                        _this.voiceTabActive = 'team'
                        // 加载团队音色列表
                        _this.loadTeamVoiceList()
                    } else {
                        _this.team_id = ''
                        _this.team_name = ''
                        _this.voiceTabActive = 'public'
                    }
                    _this.mask_visible = true
                }else if(sessionId == 1 && messageId == 13){ // 锁定模块
                    _this.mask_visible_ = true
                }else if(sessionId == 1 && messageId == 14){ // 解除锁定
                    _this.mask_visible_ = false
                }else if (sessionId == 6 && messageId == 52){
                    let arr = Protocol.deserializeBinary('proto.com.proto.s.MStrings', protoBytes).array
                    if(arr.length == 0 || arr[0].length == 0) return
                    if(_this.form_subtitles.font_family_options.length>0 || _this.form_bubble.font_family_options.length>0) return
                    for (let i = 0; i < arr[0].length; i++) {
                        _this.form_subtitles.font_family_options.push({
                            value: arr[0][i],
                            label: arr[0][i]
                        })
                        _this.form_bubble.font_family_options.push({
                            value: arr[0][i],
                            label: arr[0][i]
                        })
                    }
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
 .text
    background: #505050//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    .mask
        position: absolute;
        top: 37px;
        right: 0;
        left: 117px;
        width: 43px;
        height: 26px;
        background: rgba(191, 203, 217, .7)
        z-index: 1
    .mask_
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        width: 280px
        background: #3a3a3a//rgba(255, 255, 255,.8)
        z-index: 1
    .tabs
        display: flex
        div
            background: #3d3d3d//#f0f0f0
            color: #e2e2e2//#333
            flex: 1
            line-height: 25px
            border: 1px solid #3d3d3d
            text-align: center
            cursor: pointer
            box-sizing: border-box
        .active
            color: #e2e2e2//#2f2f2f
            background: #505050//#e8e8e8
    .con
        display: flex
        flex-direction: column
        .toolbar
            padding: 10px
            position: relative
            padding-right: 138px
            width: 100%
            box-sizing: border-box
            overflow: hidden  // 清除浮动的另一种方法
            .font-family,
            .font-size
                float: left
                width: 40%
            .font-family
                width: 69%
                .inner
                    padding-right:5px       
            .align
                position: absolute
                top: 10px
                right: 10px
                div
                    border: 1px solid #aeaeae
                    float: left
                    width: 24px
                    height:24px
                    margin-right: -1px
                    text-align: center
                    line-height: 26px;
                    color: #787878
                    font-size: 25px
                    cursor: pointer
            .active
                background: #ccc
        .subtitles
            padding: 0 10px
            .title
                padding: 10px 0 10px 0
                color:#e2e2e2
                span
                    float: right
                    color: #999
                    strong
                        color: #f00
                        font-weight: normal
            .content
                textarea
                    font-size: 12px
        .bubble
            .title
                padding: 20px 10px 5px 10px
                color:#e2e2e2
            .list
                position: absolute
                left: 0
                top: 205px
                right: 0
                bottom: 0
                overflow: auto
                margin: 5px 0 0 5px
                .con
                    overflow: hidden
                    .item
                        float: left
                        width: 80px
                        height:100px
                        margin: 0 0px 10px 7px
                        // padding: 10px
                        background: #505050//#fff
                        border: 0.5px solid #747474
                        img
                            top:0
                            height:100%
                            width: 80px
                            display: block
                .more
                    width: 90%
                    height: 32px
                    padding-left: 5%
                    .inner
                        padding: 10px
                        text-align: center
                        color: #999
                        cursor: pointer
        
        // -------------------------------------------------- [ TTS 样式 ] --------------------------------------------------
        
        // 字幕列表区域
        .subtitles-list-wrapper
            margin: 2px
            background: #3d3d3d
            border-radius: 4px
            
            .subtitles-list-header
                display: flex
                justify-content: space-between
                align-items: center
                padding: 10px 15px
                background: #4a4a4a
                border-radius: 4px 4px 0 0
                color: #e2e2e2
                font-size: 12px
                font-weight: 500
                .el-checkbox .el-checkbox__label
                    font-size: 12px!important
                
            .subtitles-list-content
                max-height: 300px
                overflow-y: auto
                padding: 4px
                
                // 自定义滚动条
                &::-webkit-scrollbar
                    width: 6px
                &::-webkit-scrollbar-track
                    background: #2d2d2d
                    border-radius: 3px
                &::-webkit-scrollbar-thumb
                    background: #666
                    border-radius: 3px
                    &:hover
                        background: #888
                
                .subtitle-item
                    display: flex
                    align-items: flex-start
                    padding: 10px
                    margin-bottom: 10px
                    background: #505050
                    border-radius: 4px
                    border: 2px solid transparent
                    transition: all 0.3s
                    cursor: pointer
                    
                    &:hover
                        background: #5a5a5a
                        border-color: #666
                    
                    &.active
                        border-color: #409EFF
                        background: #4a5a6a
                    
                    .subtitle-checkbox
                        flex-shrink: 0
                        padding-top: 8px
                        margin-right: 8px
                    
                    .subtitle-input
                        flex: 1
                        
                        textarea
                            background: #3a3a3a
                            border: 1px solid #666
                            color: #e2e2e2
                            border-radius: 4px
                            padding: 8px
                            font-size: 12px
                            line-height: 1.5
                            
                            &:focus
                                border-color: #409EFF
                                outline: none
                .empty-state
                    text-align: center
                    padding: 40px 20px
                    color: #999
                    
                    i
                        font-size: 48px
                        margin-bottom: 10px
                        display: block
                    
                    p
                        font-size: 14px
                        margin: 0
        
        // TTS 参数设置区域
        .tts-params-wrapper
            margin: 2px
            background: #3d3d3d
            border-radius: 4px
            
            .tts-params-header
                padding: 10px 15px
                background: #4a4a4a
                border-radius: 4px 4px 0 0
                color: #e2e2e2
                font-size: 12px
                font-weight: 500
                
                i
                    margin-right: 5px
                    color: #67C23A
            
            .tts-params-content
                padding: 10px
                .subtitle-voice
                    display: flex
                    justify-content: center
                    gap: 10px
                    .el-select
                        width: 100%
                .param-row
                    align-items: center
                    margin-bottom: 15px
                    
                    &:last-child
                        margin-bottom: 0
                    .param-item
                        flex: 1
                        display: flex
                        align-items: center
                        margin-right: 20px
                        
                        &:last-child
                            margin-right: 0
                        
                        label
                            flex-shrink: 0
                            color: #e2e2e2
                            font-size: 12px
                            margin-right: 10px
                            min-width: 36px
                        
                        .param-tip
                            flex-shrink: 0
                            margin-left: 10px
                            color: #999
                            font-size: 12px
        
        // 口型匹配区域
        .lip-sync-wrapper
            margin: 2px
            background: #3d3d3d
            border-radius: 4px
            
            .lip-sync-header
                padding: 10px 15px
                background: #4a4a4a
                border-radius: 4px 4px 0 0
                color: #e2e2e2
                font-size: 12px
                font-weight: 500
                
                i
                    margin-right: 5px
                    color: #409EFF
            
            .lip-sync-content
                padding: 10px
                
                .param-row
                    display: flex
                    align-items: center
                    margin-bottom: 15px
                    
                    &:last-child
                        margin-bottom: 0
                
                .lip-sync-character,
                .lip-sync-emotion
                    flex: 1
                    display: flex
                    align-items: center
                    margin-right: 10px
                    
                    &:last-child
                        margin-right: 0
                    
                    label
                        flex-shrink: 0
                        color: #e2e2e2
                        font-size: 12px
                        margin-right: 10px
                        min-width: 36px
                    
                    .el-select
                        flex: 1
                
                .param-item
                    flex: 1
                    display: flex
                    align-items: center
                    
                    label
                        flex-shrink: 0
                        color: #e2e2e2
                        font-size: 12px
                        margin-right: 10px
                        min-width: 60px
                    
                    .param-value
                        flex-shrink: 0
                        margin-left: 10px
                        color: #409EFF
                        font-size: 12px
                        font-weight: 500
                        min-width: 20px
                        text-align: center
                
                .lip-sync-actions
                    margin-top: 15px
                    display: flex
                    align-items: center
                    gap: 10px
                    
                    .auto-generate-checkbox
                        flex-shrink: 0
                        color: #e2e2e2
                        
                        /deep/ .el-checkbox__label
                            color: #e2e2e2
                            font-size: 12px
                    
                    .el-button
                        flex: 1
        // 生成按钮区域
        .tts-actions-wrapper
            margin: 2px
            padding: 15px
            background: #3d3d3d
            border-radius: 4px
            
            .tts-status
                margin-bottom: 10px
                padding: 8px 12px
                background: #4a4a4a
                border-radius: 4px
                color: #e2e2e2
                font-size: 12px
                display: flex
                align-items: center
                
                i
                    margin-right: 8px
                    font-size: 12px
                    
                    &.el-icon-loading
                        color: #409EFF
                    &.el-icon-success
                        color: #67C23A
                    &.el-icon-error
                        color: #F56C6C
            
            .tts-buttons
                display: flex
                justify-content: center
                align-items: center
                gap: 10px
                
                .el-tooltip, .el-dropdown
                    flex: 1
                
                .el-button
                    width: 56px !important
                    height: 30px
                    display: flex
                    align-items: center
                    justify-content: center
                    padding: 0
                    
                    i
                        margin: 0
                        font-size: 16px
</style>

<style lang="stylus">
// 音色管理对话框全局样式
.voice-manage-dialog
    z-index: 3000 !important
    
    .el-dialog
        margin-top: 10vh !important

    .voice-manage-content
        .voice-upload
            .el-upload-dragger
                width: 100%
                height: 150px
                
                .el-icon-upload
                    font-size: 50px
                    color: #409EFF
                    margin: 20px 0 16px
                
                .el-upload__text
                    color: #606266
                    font-size: 14px
                    
                    em
                        color: #409EFF

// 音色选择器面板（Popover渲染到body，必须用全局样式）
.voice-selector-panel
    .voice-tabs
        display: flex
        margin-bottom: 0
        border-bottom: 2px solid #e4e7ed
        
        .voice-tab
            flex: 1
            padding: 10px 0
            text-align: center
            cursor: pointer
            color: #909399
            font-size: 13px
            transition: all 0.2s
            border-bottom: 2px solid transparent
            margin-bottom: -2px
            
            &:hover
                color: #409EFF
            
            &.active
                color: #409EFF
                font-weight: 500
                border-bottom-color: #409EFF
    
    .voice-list
        max-height: 250px
        overflow-y: auto
        overflow-x: hidden
        padding-top: 6px
        
        &::-webkit-scrollbar
            width: 6px
        
        &::-webkit-scrollbar-track
            background: #f1f1f1
            border-radius: 3px
        
        &::-webkit-scrollbar-thumb
            background: #c1c1c1
            border-radius: 3px
            
            &:hover
                background: #a8a8a8
        
        .voice-list-header
            display: flex
            justify-content: center
            align-items: center
            padding: 8px 0
            
            i
                cursor: pointer
                font-size: 16px
                color: #606266
                transition: all 0.3s
                
                &:hover
                    color: #409EFF
                
                &.rotating
                    animation: rotate 1s linear infinite
        
        .voice-item
            display: flex
            align-items: center
            justify-content: space-between
            padding: 8px 12px
            cursor: pointer
            border-radius: 4px
            transition: all 0.2s
            
            &:hover
                background: #f5f7fa
            
            &.selected
                background: #ecf5ff
                color: #409EFF
            
            .voice-info
                flex: 1
                display: flex
                flex-direction: row
                align-items: center
                gap: 12px
                
                .voice-name
                    font-size: 13px
                    font-weight: 500
                
                .voice-expiration
                    font-size: 11px
                    color: #909399
                    opacity: 0.8
                    white-space: nowrap
            
            .voice-actions
                display: flex
                align-items: center
                gap: 8px
                
                i
                    cursor: pointer
                    font-size: 14px
                    
                    &.el-icon-check
                        color: #409EFF
                    
                    &.el-icon-delete
                        color: #F56C6C
                        
                        &:hover
                            color: #f00
        
        .voice-loading,
        .voice-empty
            padding: 30px
            text-align: center
            color: #909399
            font-size: 13px
            
            i
                font-size: 32px
                margin-bottom: 10px
                display: block
            
            p
                margin: 0
        
        .voice-add-btn
            margin-top: 6px
            padding: 8px
            text-align: center
            color: #409EFF
            font-size: 13px
            cursor: pointer
            border: 1px dashed #c0c4cc
            border-radius: 4px
            transition: all 0.3s
            
            &:hover
                background: #ecf5ff
                border-color: #409EFF
            
            i
                margin-right: 5px
</style>

<style lang="stylus" scoped>
 .text
    background: #505050//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    .mask
        position: absolute;
        top: 37px;
        right: 0;
        left: 117px;
        width: 43px;
        height: 26px;
        background: rgba(191, 203, 217, .7)
        z-index: 1
    .mask_
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        width: 280px
        background: #3a3a3a//rgba(255, 255, 255,.8)
        z-index: 1
    .tabs
        display: flex
</style>



// WEBPACK FOOTER //
// Text.vue?23acdca9